// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zYlV","name":"styles_name__3_aFW","phone":"styles_phone__-12i2"};